import * as React from 'react';
import {
  Box,
  Center,
  Progress,
  Separator,
  SimpleGrid,
  Spinner,
} from '@chakra-ui/react';
import {
  VStack,
} from '@ayble-health/dashboard-components';
import { Section } from './Section';
import { Tile } from './Tile';

/**
 * Raw Chakra primitives the codebase uses directly (no project wrapper).
 * ui/README.md explicitly sanctions using unopinionated primitives raw —
 * this documents which ones are actually leaned on and how often, so the
 * audit is honest about the full surface, not just the wrappers.
 */
export const PrimitiveAudit = () => (
  <Section
    id="primitives"
    title="Primitives in use"
    description="Unopinionated Chakra primitives used straight from @chakra-ui/react
      (no project wrapper). ui/README.md sanctions this for layout/atoms that
      carry no design default to protect — listed here so the audit reflects
      the whole surface."
  >
    <VStack gap={6} align="stretch">
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap={3}>
        <Tile label="Spinner" note='size="md"'>
          <Center>
            <Spinner size="md" color="seafoam" />
          </Center>
        </Tile>

        <Tile label="Separator (horizontal)">
          <Box w="100%">
            <Separator />
          </Box>
        </Tile>

        <Tile label="Separator (vertical)">
          <Center h="40px">
            <Separator orientation="vertical" height="40px" />
          </Center>
        </Tile>

        <Tile label="Progress" note='colorPalette="secondary"'>
          <Progress.Root value={64} colorPalette="secondary">
            <Progress.Track bg="secondary.50">
              <Progress.Range bg="secondary.500" />
            </Progress.Track>
          </Progress.Root>
        </Tile>
      </SimpleGrid>

    </VStack>
  </Section>
);
